module.exports = __webpack_public_path__ + "images/4128716eb16c5b1224f3bbbe7d002e22.png";